import React from "react";

import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";

import KioscoDetails from "../../kioscos-detalles/KioscoDetails";

export default function DetailModal({
    kioscoId, kioscoNro, kioscoIdentificacion, closeModal, service
}) {
    return (
        <>
            <KioscoDetails kioscoId={kioscoId} kioscoNro={kioscoNro} kioscoIdentificacion={kioscoIdentificacion} service={service} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>

        </>
    );
}